import { render, staticRenderFns } from "./LayoutSharing.vue?vue&type=template&id=38481f58&"
import script from "./LayoutSharing.vue?vue&type=script&lang=js&"
export * from "./LayoutSharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports